import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * @typedef Props
 * @prop {React.ReactNode} children
 * @prop {string} [className]
 * @prop {'default' | 'alt'} [variant]
 * @prop {boolean} [disabled]
 * @prop {string} [href]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifTextLink = (props) => {
  const { variant = 'default', className = '', disabled = false, href = '', children, ...other } = props;
  const classes = classNames({
    'motif-text-link': true,
    'motif-text-link-alt': variant === 'alt',
    'motif-text-link-disabled': disabled,
    [className]: true
  });

  return (
    <React.Fragment>
      {!disabled && (
        <a {...other} href={href} className={classes} data-motif-text-link>
          {children}
        </a>
      )}
      {disabled && (
        <a {...other} className={classes} aria-disabled="true" data-motif-text-link>
          {children}
        </a>
      )}
    </React.Fragment>
  );
};

MotifTextLink.propTypes = {
  variant: PropTypes.oneOf(['default', 'alt']),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  children: PropTypes.node
};

export { MotifTextLink };
